module.exports = __webpack_public_path__ + "static/media/letter_3@3x.2e3d1c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_3@3x.png
// module id = 585
// module chunks = 0